
import React from 'react';
import HeroSection from '../components/AboutUs/HeroSection';
import MusicFeaturesSection from '../components/AboutUs/MusicFeaturesSection';

import ArtisttoFooter from '../components/ArtisttoFooter';
import Navbar from '../components/ArtisttoHeader';
import ServicesSection from '../components/AboutUs/ServicesSection';

const AboutUs = () => {
    return (
        <>
        <Navbar/>
            <div className="font-inter">
                <HeroSection />
                <MusicFeaturesSection/>
                <ServicesSection/>
            </div>
        <ArtisttoFooter/>
        </>
    );
};

export default AboutUs;